import styled from 'styled-components';

const LogoImage = styled.img`
  width: ${props => (props.width ? props.width : '80px')};
  ${props => (props.margin ? `margin: ${props.margin};` : null)}
  vertical-align: middle;
`;

export { LogoImage };
